const main = document.querySelector('main')
const offcanvasNavbar = document.getElementById('offcanvasNavbar')
const header = document.querySelector('header')
const footer = document.querySelector('footer')
offcanvasNavbar?.addEventListener('shown.bs.offcanvas', function () {
  header?.classList.add('blur')
  main?.classList.add('blur')
  footer?.classList.add('blur')
})
offcanvasNavbar?.addEventListener('hidden.bs.offcanvas', function () {
  header?.classList.remove('blur')
  main?.classList.remove('blur')
  footer?.classList.remove('blur')
})


